import { render, staticRenderFns } from "./PreteethAIList.vue?vue&type=template&id=2ac2b3aa&scoped=true"
import script from "./PreteethAIList.vue?vue&type=script&lang=js"
export * from "./PreteethAIList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2b3aa",
  null
  
)

export default component.exports